import React, { useState } from 'react';
import usePaymentStore from '../../shared/store/use-payment-store';
import { showModalError } from '../../shared/components/modals/modal-error';
import { useCopyClipboard } from '../../shared/hooks/use-copy-clipboard';
import API from '../../../../utils/api';
import Iconify from '../../../Iconify';
import styles from './spei.module.css';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';
import iconoGeneraReferencia from '../../shared/assets/icono-genera-referencia.png';
import iconoBotonObtenerReferencia from '../../shared/assets/icono-boton-obtener-referencia.png';
import { SpeiWarnings } from '../../shared/components/spei-warnings';

export const SpeiConekta = () => {
  const { amount, isInvalidAmount } = usePaymentStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [order, setOrder] = useState(null);
  const { copyToClipboard, copiedField } = useCopyClipboard();

  const processPayment = async () => {
    setIsSubmitting(true);
    try {
      const userCancell = await waitUserCancelCashoutsPending({
        buttonConfirm: 'Generar Referencia',
        buttonCancel: 'Cancelar',
      });

      if (userCancell) {
        setIsSubmitting(false);
        return;
      }

      const data = {
        amount: 'other',
        other_amount: amount,
        method: 'spei',
      };
      const response = await API.createDepositOrder(data);

      if (response?.data?.success) {
        setOrder(response.data.order);
      } else {
        showModalError({ errorMessage: response.data.error });
      }
    } catch (error) {
      showModalError({ errorMessage: 'Ha ocurrido un error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      {!order && (
        <div className={styles.container}>
          {/* Header con icono y título */}
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <img src={iconoGeneraReferencia} alt="Icono generar referencia" />
            </div>
            <h2 className={styles.headerTitle}>
              Presiona sobre el botón para generar la referencia{' '}
              <span className={styles.headerTitleHighlight}>para tu transferencia.</span>
            </h2>
          </div>

          {/* Botón de acción */}
          <div className={styles.buttonContainer}>
            <button
              className="payment-button"
              onClick={processPayment}
              disabled={isSubmitting || isInvalidAmount}
            >
              <span className={styles.buttonText}>Obtener referencia</span>
              <img
                src={iconoBotonObtenerReferencia}
                alt="Icono obtener referencia"
                className={styles.buttonIcon}
              />
            </button>
          </div>

          {/* Información importante */}
          <div className={styles.infoBox}>
            <p className={styles.infoText}>
              Para que tu transferencia se complete con éxito asegúrate de llenar correctamente la
              cuenta <strong>CLABE, referencia y concepto.</strong>
            </p>
          </div>

          <SpeiWarnings />
        </div>
      )}

      {order && (
        <div className={styles.orderInfo}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>BANCO:</span>
            <span className={styles.infoValue}>
              {order.charges?.data?.[0]?.payment_method?.receivingAccountBank ||
                order.charges?.data?.[0]?.payment_method?.bank ||
                'FINCO PAY'}
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>CLABE:</span>
            <div className={styles.infoValueContainer}>
              <span className={styles.infoValue}>
                {order.charges?.data?.[0]?.payment_method?.clabe ||
                  order.charges?.data?.[0]?.payment_method?.receivingAccountNumber ||
                  ''}
              </span>
              <button
                className={`${styles.copyButton} ${
                  copiedField === 'clabe' ? styles.copyButtonCopied : ''
                }`}
                onClick={() =>
                  copyToClipboard(
                    order.charges?.data?.[0]?.payment_method?.clabe ||
                      order.charges?.data?.[0]?.payment_method?.receivingAccountNumber ||
                      '',
                    'clabe'
                  )
                }
              >
                <Iconify
                  icon={
                    copiedField === 'clabe'
                      ? 'material-symbols:check'
                      : 'material-symbols:content-copy'
                  }
                />
              </button>
            </div>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>CONCEPTO:</span>
            <div className={styles.infoValueContainer}>
              <span className={styles.infoValue}>{order.id || order.orderId || ''}</span>
              <button
                className={`${styles.copyButton} ${
                  copiedField === 'concepto' ? styles.copyButtonCopied : ''
                }`}
                onClick={() => copyToClipboard(order.id || order.orderId || '', 'concepto')}
              >
                <Iconify
                  icon={
                    copiedField === 'concepto'
                      ? 'material-symbols:check'
                      : 'material-symbols:content-copy'
                  }
                />
              </button>
            </div>
          </div>

          <SpeiWarnings />

          <div className={styles.buttonContainer}>
            <button
              className="payment-button"
              onClick={processPayment}
              disabled={isSubmitting || isInvalidAmount}
            >
              <span className={styles.buttonText}>
                {isSubmitting
                  ? 'GENERANDO REFERENCIA...'
                  : `GENERAR ${!!order ? ' OTRA ' : ''} REFERENCIA`}
              </span>
              {!isSubmitting && (
                <img
                  src={iconoBotonObtenerReferencia}
                  alt="Icono obtener referencia"
                  className={styles.buttonIcon}
                />
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
